<template>
  <div class="q-pa-md login-page">
    <ErrorModal v-if="hasModalError" />
    <q-form @submit="onSubmit" @reset="onReset" class="q-gutter-md login-form">
      <h4>Login</h4>
      <q-input outlined v-model="user.email" label="Email" bg-color="white" />
      <div class="password-fields">
        <q-input
          outlined
          type="password"
          v-model="user.password"
          label="Password"
          bg-color="white"
          lazy-rules
          :rules="[
            (val) =>
              (val && val.length > 5) || 'Password must have 6 characters',
          ]"
        />
        <div class="password-options">
          <q-checkbox v-model="user.right" label="Onthouden" />
        </div>
      </div>
      <div>
        <q-btn
          label="LOGIN"
          type="submit"
          color="#0a1f8f"
          style="background: #14157e"
        />
      </div>
    </q-form>
    <div class="row justify-around q-pt-md" v-if="!isDefaultEnvironment">
      <q-btn
        no-caps
        color="#0a1f8f"
        style="background: #14157e; max-width: 400px; text-decoration: none"
        label="Nog geen account? Meld je hier aan"
        :to="{ name: 'Register' }"
      />
    </div>
  </div>
</template>

<script>
import { computed, reactive, onMounted } from "vue";
import store from "../store/index.js";
import { useRouter } from "vue-router";
import ErrorModal from "./ErrorModal.vue";
import authService from "../services/auth.service.js";

export default {
  components: {
    ErrorModal,
  },
  setup() {
    const user = reactive({
      email: null,
      password: null,
      right: false,
    });

    onMounted(async () => {
      await authService.getEnvironment();
    });

    const router = useRouter();

    const isLoggedIn = computed({
      get: () => store.state.auth.isLoggedIn,
    });
    const hasModalError = computed({
      get: () => store.state.auth.hasModalError,
    });

    const hasComeFromNewsletter = computed({
      get: () => store.state.user.hasComeFromNewsletter,
    });

    const newsletterId = computed({
      get: () => store.state.user.newsLetterId,
    });

    if (isLoggedIn.value == true) {
      router.push({
        name: "StatisticsOverview",
      });
    }

    const onSubmit = async () => {
        await authService.login(user)
        .then(() => {
          router.push({
            name: "StatisticsOverview",
          });
        });
    };

    const isDefaultEnvironment = computed({
      get: () => store.state.auth.env === 0 || store.state.auth.env === 40,
    });

    return {
      newsletterId,
      hasComeFromNewsletter,
      onSubmit,
      router,
      isLoggedIn,
      hasModalError,
      user,
      isDefaultEnvironment,
      onReset() {
        user.email.value = null;
        user.password.value = null;
      },
    };
  },
};
</script>
